import React, { useState } from "react";
//? Styles
import { styleScreenDashboard } from "../styles/style";
import "../styles/style.css";
// ? Components
//? header
import Header from "../components/header/header";
//? options column
//import ColumOptions from "../components/columnOptions/columnOptions";
//? custom alert
import CustomAlert from "../components/alerts/customAlert";
//? assignment of order
import AssignOrder from "./assignOrder";
//? send reminders to shops
import SendedOrders from "./sendedOrders";
//? flow orders
import Orders from "./orders";
//? Aiura
import Help from "./help";

function Dashboard() {
  //? Alert
  //? control
  const [showAlert, setShowAlert] = useState(false);
  //? title, content, alert variant
  const [titleAlert, setTitleAlert] = useState("");
  const [contentAlert, setContentAlert] = useState("");
  const [variantAlert, setVariantAlert] = useState("");
  //? selected option
  const [selectedOption, setSelectedOption] = useState("");

  /**
   * Function to show alert in dashboard
   * @param {String} title title of the alert
   * @param {*} content content of the alert
   * @param {*} variant variant of the alert (primary, secondary, success, danger, warning, info, light, dark)
   */
  const messageAssignOrder = (title, content, variant) => {
    setShowAlert(true);
    setTitleAlert(title);
    setContentAlert(content);
    setVariantAlert(variant);
  };

  const optionSideBarSelected = (option) => {
    setSelectedOption(option);
  };

  const RenderOption = () => {
    switch (selectedOption) {
      case "pending":
        return (
          <SendedOrders
            messageAssignOrder={messageAssignOrder}
            optionSideBarSelected={optionSideBarSelected}
          />
        );
      case "assign":
        return (
          <AssignOrder
            messageAssignOrder={messageAssignOrder}
            optionSideBarSelected={optionSideBarSelected}
          />
        );
      case "help":
        return <Help />;
      case "orders":
        return <Orders optionSideBarSelected={optionSideBarSelected} />;
      default:
        return (
          <AssignOrder
            messageAssignOrder={messageAssignOrder}
            optionSideBarSelected={optionSideBarSelected}
          />
        );
    }
  };

  return (
    <div className="container" style={styleScreenDashboard.principalContainer}>
      <Header onSelectOption={optionSideBarSelected} />
      <CustomAlert
        show={showAlert}
        setShow={setShowAlert}
        title={titleAlert}
        content={contentAlert}
        variantAlert={variantAlert}
      />
      <RenderOption />
    </div>
  );
}

export default Dashboard;
